export enum MessagesEnum {
  REQUIRED_ALL_FIELDS = 'Please fill all the required fields',
  POPUP_BLOCKED = 'Failed to open new tab. Please allow pop-ups for this website',
  INVALID_FORMAT = 'Please fill the fields in valid format',
}
